var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__wrapper wrapper"},[_c('div',{staticClass:"footer__mention"},[_vm._v(_vm._s(_vm.text.mention[0][_vm.lang]))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }